import { IconsInitConfigType } from './icon.constants';
import { ToastType } from '../types/toast.type';

export const TOAST_ICON_BY_TYPE: Record<ToastType, IconsInitConfigType> = {
  success: 'checkmark-2-20',
  error: 'x-2-20',
  warning: 'warning-20',
  info: 'info-20',
};

/** Matches the `timeOut` default the app ran on under ngx-toastr. */
export const TOAST_DEFAULT_TIMEOUT = 5000;

/** Grace period after the pointer leaves a hovered toast. */
export const TOAST_EXTENDED_TIMEOUT = 1000;

/** At most this many toasts are on screen; the oldest is dropped to make room. */
export const TOAST_MAX_OPENED = 3;
